<template>
  <div class="create-tracking-category-duration-popup">
    <colored-popup class="primary" :back-action="back">
      <template v-slot:top-content>
        <div class="title">הוספת קטגוריה למעקב</div>
      </template>

      <template v-slot:bottom-content>
        <div class="popup-bottom-content">
          <div class="sub-title">באיזה חודשים לפתוח את הקטגוריה?</div>

          <div class="duration-options">
            <radio-button-card
              :title="'מהחודש הנוכחי והלאה'"
              :selected="selectedDuration === durationOptions.CURRENT_AND_FUTURE"
              @click="selectDuration(durationOptions.CURRENT_AND_FUTURE)" />

            <radio-button-card
              :title="'בכל החודשים - בעבר, בנוכחי והלאה'"
              :selected="selectedDuration === durationOptions.ALL_MONTHS"
              @click="selectDuration(durationOptions.ALL_MONTHS)" />

            <radio-button-card
              :title="'רק בחודש הנוכחי'"
              :selected="selectedDuration === durationOptions.CURRENT_ONLY"
              @click="selectDuration(durationOptions.CURRENT_ONLY)" />
          </div>

          <riseup-button
            class="save-button"
            :action="save"
            :loading="saving"
            variant="primary"
            size="slim"
            title="הוספת קטגוריה" />
        </div>
      </template>
    </colored-popup>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import BaseUI from '@riseupil/base-ui';
import EventBus from '@/event-bus/event-bus';
import Segment from '@/Segment';
import NewTrackingCategoryToaster
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/toasters/NewTrackingCategoryToaster';
import { CATEGORY_DURATION_OPTIONS } from '@/store/modules/create-tracking-category';
import RadioButtonCard from '../RadioButtonCard.vue';
import MoveVariablesMixin from './MoveVariablesMixin';

export default {
  name: 'CreateTrackingCategoryDurationPopup',
  mixins: [MoveVariablesMixin],
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    RiseupButton: BaseUI.RiseupButton,
    RadioButtonCard,
  },
  data() {
    return {
      selectedDuration: CATEGORY_DURATION_OPTIONS.CURRENT_AND_FUTURE,
      saving: false,
    };
  },
  computed: {
    ...mapState('createTrackingCategory', ['selectedTrackingCategory', 'categoryDuration']),
    ...mapState('cashflowView', ['cashflow']),
    ...mapGetters('editTransaction', ['ENRICHMENT_INPUT_TYPES']),
    ...mapGetters('createTrackingCategory', ['transactionsToTrack']),
    durationOptions() {
      return CATEGORY_DURATION_OPTIONS;
    },
  },
  created() {
    this.selectedDuration = this.categoryDuration;
    Segment.trackUserInteraction('CreateTrackingCategoryDuration_Entered');
  },
  methods: {
    ...mapActions('createTrackingCategory', ['setCategoryDuration', 'showTrackingCategory']),
    ...mapActions('editCashflow', ['moveTransaction']),
    selectDuration(duration) {
      this.selectedDuration = duration;
    },
    back() {
      Segment.trackUserInteraction('CreateTrackingCategoryDuration_BackClicked');
      this.$emit('back-clicked');
    },
    async save() {
      if (this.saving) {
        return;
      }
      this.saving = true;
      Segment.trackUserInteraction('CreateTrackingCategoryDuration_SaveClicked', {
        categoryDuration: this.selectedDuration,
      });
      await this.setCategoryDuration(this.selectedDuration);
      const newTrackingCategory = await this.showTrackingCategory();
      _.forEach(this.transactionsToTrack, transaction => {
        this.moveTransaction({
          originalCategory: transaction.trackingCategory,
          selectedCategory: newTrackingCategory,
          transaction,
          categoryRuleType: this.ENRICHMENT_INPUT_TYPES.TRANSACTION_ID,
          valueForPredicate: transaction.transactionId,
        });
      });
      const { name: categoryName, trackingCategoryId } = newTrackingCategory;
      await this.moveExistingTransactionsFromVariablesToCategory({ categoryName, trackingCategoryId });
      EventBus.$emit('open-toaster', {
        component: NewTrackingCategoryToaster,
        props: {
          trackingCategoryName: this.selectedTrackingCategory.label,
        },
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/spacings';

.create-tracking-category-duration-popup {
  height: 100%;

  #popup {
    height: 100%;
  }

  .bottom {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .colored-top .title {
    font-size: 22px;
    line-height: 22px;
    font-weight: bold;
    color: $riseup_white;
    text-align: right;
  }

  .popup-bottom-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;

    .sub-title {
      margin-top: 24px;
      margin-bottom: 12px;
      font-size: 16px;
      font-weight: normal;
      text-align: right;
      color: $riseup_black;
    }

    .duration-options {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 48px;

      .radio-button-card {
        padding: 16px 12px;
        color: $riseup_black !important;

        .title-container {
          font-weight: normal;

          .title {
            color: $riseup_black !important;
            font-weight: normal;
            text-align: right;
          }
        }
      }
    }

    .save-button {
      margin-top: auto;
    }
  }
}
</style>
